import AccessControlDeviceData from "@/http/data/access-control-device-data";
import AccessControlCardData from "@/http/data/access-control-card-data";
import AccessControlEventPageData from "@/http/data/access-control-event-page-data";
import AccessControlDoorData from "@/http/data/access-control-door-data";

export enum AccessControlStatus {
    Failed = "failed",
    NotImplemented = "not_implemented",
    Unauthenticated = "unauthenticated",
    Forbidden = "forbidden",
    Empty = "empty",
    Ready = "ready",
    Loading = "loading"
}

export default class AccessControlState {
    devices: AccessControlDeviceData[] = [];
    devicesByBuildingId: Record<string, AccessControlDeviceData[]> = {};
    devicesCacheExpiresAtByBuildingId: Record<string, number> = {};
    accessControlStatusByBuildingId: Record<string, AccessControlStatus> = {};
    deviceDetailsById: Record<number, AccessControlDeviceData> = {};
    cardNumbersByDeviceId: Record<number, number[]> = {};
    cardDetailsByDeviceId: Record<number, Record<number, AccessControlCardData>> = {};
    doorsByDeviceId: Record<number, AccessControlDoorData[]> = {};
    doorDetailsByDeviceId: Record<number, Record<number, AccessControlDoorData>> = {};
    eventsPagesByDeviceId: Record<number, Record<number, AccessControlEventPageData>> = {};
    selectedDeviceId: null | number = null;
    selectedCardNumber: null | number = null;
    selectedDoorId: null | number = null;
    selectedEventsPageNumber = 1;
    accessControlStatus: AccessControlStatus = AccessControlStatus.Failed;
    isInitialized = false;
}
